var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-alert',{staticStyle:{"margin-top":"1rem"},attrs:{"title":_vm.$t('PcMayNotBeConnectedWarning'),"type":"warning","show-icon":""}}),_c('div',{staticClass:"image-login"},[_c('el-image',{ref:"image",staticStyle:{"height":"200px"},attrs:{"src":_vm.url,"preview-src-list":_vm.srcList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }